
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mall",
      function () {
        return require("private-next-pages/mall/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mall"])
      });
    }
  